module.exports = __webpack_public_path__ + "u.no2.ad63cd5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/u.no2.jpg
// module id = /Cf6
// module chunks = 0